
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34396',
  depVersions: {
  "documents-public-ui": "static-1.34396",
  "client-types": "static-1.461",
  "documents-lib": "static-1.34401",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2090",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5551",
  "hs-test-utils": "static-1.7974",
  "hub-http": "static-1.6179",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11419",
  "I18n": "static-7.1612",
  "jasmine-immutable": "static-1.2976",
  "jasmine-runner": "static-1.6427",
  "lodash": "static-1.3",
  "quartz": "static-1.6965",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16627",
  "reporting-data": "static-1.67321",
  "reporting-testing-lib": "static-1.9254",
  "reporting-visualizations": "static-1.59397",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4727",
  "webpack-env": "static-1.54",
  "atom": "static-1.5030",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2456",
  "classnames": "static-2.10",
  "cssUtils": "static-1.780",
  "customer-data-filters-ui": "static-1.39582",
  "customer-data-objects": "static-1.7622",
  "customer-data-property-utils": "static-1.8041",
  "data-fetching-client": "static-1.9632",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4479",
  "flux-actions": "static-1.331",
  "FormsCommonComponents": "static-1.85702",
  "FormUrlGenerator": "static-2.4677",
  "foundations-components": "static-1.7845",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11727",
  "icons": "static-2.644",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7116",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3804",
  "property-translator": "static-1.5359",
  "quartz-config": "static-1.743",
  "quartz-core": "static-1.6184",
  "quick-fetch": "static-1.3882",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5309",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8128",
  "reference-resolvers-lite": "static-1.8053",
  "report-customization-components": "static-1.13034",
  "reporting-enablement": "static-1.22741",
  "reporting-reports": "static-1.66999",
  "reporting-snowflake": "static-1.55939",
  "reporting-ui-components": "static-2.64592",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4608",
  "sales-content-partitioning": "static-1.8895",
  "SalesContentIndexUI": "static-3.9176",
  "sanitize": "static-1.4430",
  "sanitize-text": "static-1.8101",
  "self-service-api": "static-1.10203",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1704",
  "signup-constants": "static-1.18758",
  "signup-ui-lego-core": "static-1.20768",
  "signup-ui-url-generator": "static-2.7998",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4724",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10946",
  "ui-addon-i18n": "static-1.11108",
  "ui-addon-react-router-dom": "static-1.9503",
  "ui-addon-upgrades": "static-9.17923",
  "ui-asset-management-lib": "static-1.10967",
  "ui-images": "static-2.1141",
  "UIComponents": "static-3.8366",
  "usage-tracker": "static-1.7297",
  "usage-tracker-container": "static-1.7287",
  "usage-tracker-core": "static-1.7147",
  "usage-tracker-public": "static-1.7108",
  "viral-links-lib": "static-1.7013",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3368",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3242",
  "quartz-webpack": "static-1.3189",
  "ai-components-ui-library": "static-1.8812",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4814",
  "foundations-theming": "static-1.4374",
  "quartz-auth": "static-1.640",
  "ui-business-units-lib": "static-1.9006",
  "usage-tracker-session-replay": "static-1.4983",
  "foundations-theming-base": "static-1.3359",
  "HeadJS": "static-2.741",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3085",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.49",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4282",
  "csstype": "static-1.50",
  "quartz-head": "static-1.630",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7885",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3556",
  "persist-promise": "static-1.3665",
  "quartz-i18n": "static-1.640",
  "reporting-client-types": "static-1.2472",
  "foundations-components-legacy": "static-1.870",
  "hs-story-utils": "static-1.9387",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9855",
  "hubspotter-http": "static-1.4617",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7206",
  "crm-message-bus": "static-1.42856",
  "customer-data-filters-ui-msw-helpers": "static-1.22017",
  "customer-data-objects-ui-components": "static-1.12983",
  "customer-data-reference-ui-components": "static-1.13117",
  "customer-data-ui-utilities": "static-1.9784",
  "framework-builder-read-service-client": "static-1.3975",
  "framework-data-schema-quick-fetch": "static-1.6741",
  "framework-data-schema-resolvers": "static-1.6836",
  "inbound-db-properties-service-client": "static-1.3806",
  "multi-account-reference-resolvers": "static-1.937",
  "onboarding-tours": "static-1.16509",
  "reporting-datasets-permissions-lib": "static-1.13534",
  "ui-addon-teams": "static-1.21489",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68223",
  "customer-data-properties": "static-1.51378",
  "forms-ai-lib": "static-1.4244",
  "forms-utils-lib": "static-1.12493",
  "foundations-components-test-utils": "static-1.5328",
  "react-dnd-compat": "static-1.4578",
  "react-tinymce": "static-1.55106",
  "tinymce-config": "static-2.54232",
  "ui-gdpr-components": "static-1.10305",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4114",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.11",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1711",
  "ui-fonts": "static-1.681",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.827",
  "mobile-manifest-mixins": "static-1.515",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.395",
  "quartz-test": "static-1.640",
  "quartz-tracking": "static-1.344",
  "batch-promise": "static-1.1508",
  "external-options-client-types": "static-1.4124",
  "react-colorpicker": "static-2.10168",
  "copilot-toolkit": "static-1.10992",
  "data-quality-ui-library": "static-1.12792",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6420",
  "reporting-action-components": "static-1.41172",
  "reporting-filters": "static-1.194",
  "reporting-insights-lib": "static-1.1589",
  "reporting-plugins": "static-1.10214",
  "ui-addon-draggable-compat": "static-2.4212",
  "ui-addon-opt": "static-4.8331",
  "zustand": "static-1.74",
  "growth-payments-core": "static-1.25225",
  "hubspot-apollo-client": "static-1.4834",
  "bend-plugin-chirp-manifest": "static-1.18",
  "chirp-fetch": "static-1.1843",
  "sales-templates-service-types-lib": "static-1.4133",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5801",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4043",
  "nested-table": "static-1.183",
  "timezone-utils": "static-2.5202",
  "bender-build-tools": "static-1.3123",
  "chatspot-core": "static-1.21056",
  "bend-plugin-foundations-theming": "static-1.2857",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9853",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3762",
  "crm-pipelines-api-client-types": "static-1.4108",
  "multi-currency-client-types": "static-1.3657",
  "getting-started-shared-tasks": "static-1.18360",
  "growth-data-modal": "static-1.5354",
  "growth-onboarding-confetti": "static-1.3025",
  "growth-onboarding-next-action-utils": "static-1.1772",
  "navigation-components": "static-1.17872",
  "onboarding-tours-client": "static-1.4723",
  "onboarding-tours-utils": "static-1.575",
  "ui-shepherd-react": "static-3.10106",
  "ui-shepherd-tracker": "static-1.7487",
  "ui-universal-auth": "static-1.8921",
  "user-context": "static-1.5059",
  "cms-field-types": "static-1.4769",
  "content-icons-ui": "static-1.2214",
  "integrations-lib": "static-1.15963",
  "calling-global-api": "static-1.64343",
  "calling-internal-common": "static-1.31260",
  "calling-lifecycle-internal": "static-1.65725",
  "calling-lifecycle-messages": "static-1.58019",
  "commerce-products-lib": "static-1.9352",
  "crm-links": "static-1.6241",
  "customer-data-properties-shared-msw-handlers": "static-1.9182",
  "file-manager-components": "static-1.23487",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.106",
  "inbounddb-objects-service-types": "static-1.4189",
  "meetings-icalendar-utils-lib": "static-1.589",
  "object-builder-ui-client": "static-1.48572",
  "pipeline-validation-client-types": "static-1.3931",
  "property-value-citations": "static-1.1992",
  "pulse": "static-1.519",
  "smart-property-lib": "static-1.6689",
  "tiered-pricing": "static-1.1114",
  "ui-addon-iframeable": "static-1.9013",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19751",
  "tinymce-themes": "static-1.56202",
  "data-token-picker": "static-1.16325",
  "hub-http-contrib": "static-1.2998",
  "interframe": "static-3.4719",
  "tinymce-data": "static-1.40317",
  "tinymce-plugins": "static-1.57346",
  "ui-addon-sales-email": "static-1.5168",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5532",
  "magpie-types": "static-1.4992",
  "simple-logging-lib": "static-1.3007",
  "content-assistance-lib": "static-1.7681",
  "dashboard-lib": "static-1.81334",
  "ExportDialog": "static-6.10351",
  "hubspot-prosemirror": "static-1.18098",
  "hubspot-prosemirror-plugins": "static-1.18090",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8655",
  "campaign-roi-lib": "static-1.8935",
  "feedback-loader": "static-1.29214",
  "apollo-link-hub-http": "static-2.4606",
  "hubspot-apollo-cache": "static-1.293",
  "purchase-motions-api": "static-1.5804",
  "trials-service-types": "static-1.3861",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.131",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1885",
  "growth-onboarding-next-action-components": "static-1.1800",
  "user-context-client": "static-1.4568",
  "idb-keyval": "static-1.43",
  "nest": "static-1.185",
  "reactive-lib": "static-1.679",
  "unified-auth-core-lib": "static-1.716",
  "getting-started-shared-tasks-store": "static-1.17478",
  "integrations-error-boundary-lib": "static-1.13378",
  "integrations-tracking-lib": "static-1.5556",
  "native-integrations-shared-strings": "static-1.7741",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10329",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.435",
  "calling-error-reporting": "static-1.31266",
  "shared-worker-versioning": "static-1.10995",
  "calling-usage-tracker": "static-1.6500",
  "voice-sms-access-library": "static-1.793",
  "customer-data-tracking": "static-1.6843",
  "commerce-permissions": "static-1.723",
  "products-iframe-lib": "static-1.7788",
  "products-ui-components-shared-msw-handlers": "static-1.10237",
  "location-customization-utils-lib": "static-1.9101",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4111",
  "video-components-external": "static-1.11110",
  "video-data-lib": "static-1.34768",
  "bend-plugin-pulse": "static-1.22",
  "directed-graph": "static-1.893",
  "event-emitter": "static-1.906",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.120",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9938",
  "fsm": "static-1.3690",
  "policy-lib": "static-1.6730",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10001",
  "navigation-messaging": "static-1.7199",
  "FileManagerLib": "static-1.39127",
  "NamespacedHubStyle": "static-2.9028",
  "FileManagerCore": "static-1.38986",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12356",
  "layout-dnd-utils": "static-1.11331",
  "react-codemirror": "static-1.10581",
  "ui-addon-emoji-picker": "static-1.9846",
  "ui-brand-identity-lib": "static-1.15041",
  "ui-addon-video-player": "static-1.8656",
  "ui-coaching-tips": "static-1.28410",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23400",
  "EmailSignatureEditor": "static-1.24273",
  "InboxConnectUtils": "static-4.14667",
  "universal-page-editor-lib": "static-1.2970",
  "google-sheets-integration-lib": "static-1.95",
  "microsoft-drive-integration-lib": "static-1.208",
  "calling-orchestration-schema": "static-1.35570",
  "sales-views-client-types": "static-1.4222",
  "crm-record-cards-service-types": "static-1.3575",
  "content-media-composition-data-lib": "static-1.12089",
  "content-media-compositions": "static-2.16096",
  "media-bridge-lib": "static-1.18847",
  "trellis-story-utils": "static-1.4473",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5846",
  "FileManagerImages": "static-1.36638",
  "video-components": "static-1.13113",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4489",
  "video-embed": "static-1.35602",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68298",
  "layout-data-lib": "static-1.9656",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6541",
  "commerce-tours-lib": "static-1.6009",
  "growth-onboarding-reliability": "static-1.5039",
  "sales-checkout-service-client": "static-1.3597",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21591",
  "sales-email-signature-service-client": "static-1.3801",
  "social-insights-client-types": "static-1.21954",
  "outpost": "static-1.4146",
  "advanced-menus-core": "static-1.15055",
  "advanced-menus-lib": "static-1.12006",
  "ui-memberships-settings-lib": "static-1.33914",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15054",
  "simple-menus-lib": "static-1.16571"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34396",
  "client-types": "/client-types/static-1.461",
  "documents-lib": "/documents-lib/static-1.34401",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2090",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5551",
  "hs-test-utils": "/hs-test-utils/static-1.7974",
  "hub-http": "/hub-http/static-1.6179",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11419",
  "I18n": "/I18n/static-7.1612",
  "jasmine-immutable": "/jasmine-immutable/static-1.2976",
  "jasmine-runner": "/jasmine-runner/static-1.6427",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6965",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16627",
  "reporting-data": "/reporting-data/static-1.67321",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9254",
  "reporting-visualizations": "/reporting-visualizations/static-1.59397",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4727",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5030",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2456",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.780",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39582",
  "customer-data-objects": "/customer-data-objects/static-1.7622",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8041",
  "data-fetching-client": "/data-fetching-client/static-1.9632",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4479",
  "flux-actions": "/flux-actions/static-1.331",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85702",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4677",
  "foundations-components": "/foundations-components/static-1.7845",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11727",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7116",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3804",
  "property-translator": "/property-translator/static-1.5359",
  "quartz-config": "/quartz-config/static-1.743",
  "quartz-core": "/quartz-core/static-1.6184",
  "quick-fetch": "/quick-fetch/static-1.3882",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5309",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8128",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8053",
  "report-customization-components": "/report-customization-components/static-1.13034",
  "reporting-enablement": "/reporting-enablement/static-1.22741",
  "reporting-reports": "/reporting-reports/static-1.66999",
  "reporting-snowflake": "/reporting-snowflake/static-1.55939",
  "reporting-ui-components": "/reporting-ui-components/static-2.64592",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4608",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8895",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9176",
  "sanitize": "/sanitize/static-1.4430",
  "sanitize-text": "/sanitize-text/static-1.8101",
  "self-service-api": "/self-service-api/static-1.10203",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1704",
  "signup-constants": "/signup-constants/static-1.18758",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20768",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7998",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4724",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10946",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11108",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9503",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17923",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10967",
  "ui-images": "/ui-images/static-2.1141",
  "UIComponents": "/UIComponents/static-3.8366",
  "usage-tracker": "/usage-tracker/static-1.7297",
  "usage-tracker-container": "/usage-tracker-container/static-1.7287",
  "usage-tracker-core": "/usage-tracker-core/static-1.7147",
  "usage-tracker-public": "/usage-tracker-public/static-1.7108",
  "viral-links-lib": "/viral-links-lib/static-1.7013",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3368",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3242",
  "quartz-webpack": "/quartz-webpack/static-1.3189",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8812",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4814",
  "foundations-theming": "/foundations-theming/static-1.4374",
  "quartz-auth": "/quartz-auth/static-1.640",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9006",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4983",
  "foundations-theming-base": "/foundations-theming-base/static-1.3359",
  "HeadJS": "/HeadJS/static-2.741",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3085",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.49",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4282",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.630",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7885",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3556",
  "persist-promise": "/persist-promise/static-1.3665",
  "quartz-i18n": "/quartz-i18n/static-1.640",
  "reporting-client-types": "/reporting-client-types/static-1.2472",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.870",
  "hs-story-utils": "/hs-story-utils/static-1.9387",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9855",
  "hubspotter-http": "/hubspotter-http/static-1.4617",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7206",
  "crm-message-bus": "/crm-message-bus/static-1.42856",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22017",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12983",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13117",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9784",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3975",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6741",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6836",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3806",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.937",
  "onboarding-tours": "/onboarding-tours/static-1.16509",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13534",
  "ui-addon-teams": "/ui-addon-teams/static-1.21489",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68223",
  "customer-data-properties": "/customer-data-properties/static-1.51378",
  "forms-ai-lib": "/forms-ai-lib/static-1.4244",
  "forms-utils-lib": "/forms-utils-lib/static-1.12493",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5328",
  "react-dnd-compat": "/react-dnd-compat/static-1.4578",
  "react-tinymce": "/react-tinymce/static-1.55106",
  "tinymce-config": "/tinymce-config/static-2.54232",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10305",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4114",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.11",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1711",
  "ui-fonts": "/ui-fonts/static-1.681",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.827",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.515",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.395",
  "quartz-test": "/quartz-test/static-1.640",
  "quartz-tracking": "/quartz-tracking/static-1.344",
  "batch-promise": "/batch-promise/static-1.1508",
  "external-options-client-types": "/external-options-client-types/static-1.4124",
  "react-colorpicker": "/react-colorpicker/static-2.10168",
  "copilot-toolkit": "/copilot-toolkit/static-1.10992",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12792",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6420",
  "reporting-action-components": "/reporting-action-components/static-1.41172",
  "reporting-filters": "/reporting-filters/static-1.194",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1589",
  "reporting-plugins": "/reporting-plugins/static-1.10214",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4212",
  "ui-addon-opt": "/ui-addon-opt/static-4.8331",
  "zustand": "/zustand/static-1.74",
  "growth-payments-core": "/growth-payments-core/static-1.25225",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4834",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.18",
  "chirp-fetch": "/chirp-fetch/static-1.1843",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4133",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5801",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4043",
  "nested-table": "/nested-table/static-1.183",
  "timezone-utils": "/timezone-utils/static-2.5202",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "chatspot-core": "/chatspot-core/static-1.21056",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2857",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9853",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3762",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4108",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3657",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18360",
  "growth-data-modal": "/growth-data-modal/static-1.5354",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3025",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1772",
  "navigation-components": "/navigation-components/static-1.17872",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4723",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.575",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10106",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7487",
  "ui-universal-auth": "/ui-universal-auth/static-1.8921",
  "user-context": "/user-context/static-1.5059",
  "cms-field-types": "/cms-field-types/static-1.4769",
  "content-icons-ui": "/content-icons-ui/static-1.2214",
  "integrations-lib": "/integrations-lib/static-1.15963",
  "calling-global-api": "/calling-global-api/static-1.64343",
  "calling-internal-common": "/calling-internal-common/static-1.31260",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65725",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58019",
  "commerce-products-lib": "/commerce-products-lib/static-1.9352",
  "crm-links": "/crm-links/static-1.6241",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9182",
  "file-manager-components": "/file-manager-components/static-1.23487",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.106",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4189",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.589",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48572",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3931",
  "property-value-citations": "/property-value-citations/static-1.1992",
  "pulse": "/pulse/static-1.519",
  "smart-property-lib": "/smart-property-lib/static-1.6689",
  "tiered-pricing": "/tiered-pricing/static-1.1114",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9013",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19751",
  "tinymce-themes": "/tinymce-themes/static-1.56202",
  "data-token-picker": "/data-token-picker/static-1.16325",
  "hub-http-contrib": "/hub-http-contrib/static-1.2998",
  "interframe": "/interframe/static-3.4719",
  "tinymce-data": "/tinymce-data/static-1.40317",
  "tinymce-plugins": "/tinymce-plugins/static-1.57346",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5168",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5532",
  "magpie-types": "/magpie-types/static-1.4992",
  "simple-logging-lib": "/simple-logging-lib/static-1.3007",
  "content-assistance-lib": "/content-assistance-lib/static-1.7681",
  "dashboard-lib": "/dashboard-lib/static-1.81334",
  "ExportDialog": "/ExportDialog/static-6.10351",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18098",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18090",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8655",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8935",
  "feedback-loader": "/feedback-loader/static-1.29214",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4606",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.293",
  "purchase-motions-api": "/purchase-motions-api/static-1.5804",
  "trials-service-types": "/trials-service-types/static-1.3861",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.131",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1885",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1800",
  "user-context-client": "/user-context-client/static-1.4568",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.185",
  "reactive-lib": "/reactive-lib/static-1.679",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.716",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17478",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13378",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5556",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7741",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10329",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.435",
  "calling-error-reporting": "/calling-error-reporting/static-1.31266",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10995",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6500",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.793",
  "customer-data-tracking": "/customer-data-tracking/static-1.6843",
  "commerce-permissions": "/commerce-permissions/static-1.723",
  "products-iframe-lib": "/products-iframe-lib/static-1.7788",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10237",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9101",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4111",
  "video-components-external": "/video-components-external/static-1.11110",
  "video-data-lib": "/video-data-lib/static-1.34768",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.22",
  "directed-graph": "/directed-graph/static-1.893",
  "event-emitter": "/event-emitter/static-1.906",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.120",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9938",
  "fsm": "/fsm/static-1.3690",
  "policy-lib": "/policy-lib/static-1.6730",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10001",
  "navigation-messaging": "/navigation-messaging/static-1.7199",
  "FileManagerLib": "/FileManagerLib/static-1.39127",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9028",
  "FileManagerCore": "/FileManagerCore/static-1.38986",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12356",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11331",
  "react-codemirror": "/react-codemirror/static-1.10581",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9846",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15041",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8656",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28410",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23400",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24273",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14667",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2970",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.95",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.208",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35570",
  "sales-views-client-types": "/sales-views-client-types/static-1.4222",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3575",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12089",
  "content-media-compositions": "/content-media-compositions/static-2.16096",
  "media-bridge-lib": "/media-bridge-lib/static-1.18847",
  "trellis-story-utils": "/trellis-story-utils/static-1.4473",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5846",
  "FileManagerImages": "/FileManagerImages/static-1.36638",
  "video-components": "/video-components/static-1.13113",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4489",
  "video-embed": "/video-embed/static-1.35602",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68298",
  "layout-data-lib": "/layout-data-lib/static-1.9656",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6541",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6009",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5039",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3597",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21591",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3801",
  "social-insights-client-types": "/social-insights-client-types/static-1.21954",
  "outpost": "/outpost/static-1.4146",
  "advanced-menus-core": "/advanced-menus-core/static-1.15055",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12006",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33914",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15054",
  "simple-menus-lib": "/simple-menus-lib/static-1.16571"
}
};
